module.exports = require("@swa-ui/design-tokens/src/generated/platforms/scss/business-dark.module.scss");